import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatGridListModule } from '@angular/material/grid-list';
import { AreaChartModule, BubbleChartModule, ChartCommonModule, LineChartModule } from '@swimlane/ngx-charts';
import { RatingModule } from 'ng-starrating';
import { ChartsModule } from 'ng2-charts';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { PumpVolumeStatsComponent } from '~lmo/kpidashboard/pump-volume-stats/pump-volume-stats.component';
import { MaterialModule } from '../material-module/material.module';
import { UIComponentsModule } from '../ui-components/ui-components.module';
import { components, entryComponents } from './components';
import { LmoOrdersReplacementDriverOnOrderComponent } from './components/lmo-orders-replacement/lmo-orders-replacement-driver-on-order/lmo-orders-replacement-driver-on-order.component';
import { LmoOrdersReplacementComponent } from './components/lmo-orders-replacement/lmo-orders-replacement.component';
import { LmoPurchaseOrderAddSupportedWellComponent } from './components/lmo-purchase-orders/lmo-purchase-order-detail/lmo-purchase-order-add-supported-well/lmo-purchase-order-add-supported-well.component';
import { containers } from './containers';
import { LmoFracListModalComponent } from './containers/lmo-frac-list-modal/lmo-frac-list-modal.component';
import { AverageTurnRateComponent } from './kpidashboard/average-turn-rate/average-turn-rate.component';
import { CarrierSelectorComponent } from './kpidashboard/average-turn-rate/carrier-selector/carrier-selector.component';
import { CarrierStatsComponent } from './kpidashboard/carrier-stats/carrier-stats.component';
import { DriverWithCompletedLoadsComponent } from './kpidashboard/driver-with-completed-loads/driver-with-completed-loads.component';
import { FracSelectorComponent } from './kpidashboard/frac-selector/frac-selector.component';
import { FracsStatsComponent } from './kpidashboard/fracs-stats/fracs-stats.component';
import { KPIDashboardComponent } from './kpidashboard/kpidashboard.component';
import { MedianSelectorComponent } from './kpidashboard/median-selector/median-selector.component';
import { PendingLoadByHourComponent } from './kpidashboard/pending-load-by-hour/pending-load-by-hour.component';
import { RegionSelectorComponent } from './kpidashboard/region-selector/region-selector.component';
import { StatsComponent } from './kpidashboard/stats/stats.component';
import { TimeToNPTComponent } from './kpidashboard/time-to-npt/time-to-npt.component';
import { TimeFrameSelectorComponent } from './kpidashboard/timeframe-selector/timeframe-selector.component';
import { LmoRoutingModule } from './lmo-routing.module';
import { pipes } from './pipes';
import { FracNameFromIdPipe } from './pipes/frac-name.pipe';
import { OrderIdPipe } from './pipes/order-id.pipe';

@NgModule({
  declarations: [
    ...containers,
    ...components,
    ...pipes,
    LmoFracListModalComponent,
    FracNameFromIdPipe,
    OrderIdPipe,
    LmoOrdersReplacementComponent,
    LmoOrdersReplacementDriverOnOrderComponent,
    LmoPurchaseOrderAddSupportedWellComponent,
    KPIDashboardComponent,
    RegionSelectorComponent,
    TimeFrameSelectorComponent,
    MedianSelectorComponent,
    StatsComponent,
    DriverWithCompletedLoadsComponent,
    AverageTurnRateComponent,
    PendingLoadByHourComponent,
    FracsStatsComponent,
    CarrierStatsComponent,
    TimeToNPTComponent,
    FracSelectorComponent,
    CarrierSelectorComponent,
    PumpVolumeStatsComponent,
  ],
  entryComponents,
  exports: [OrderIdPipe],
  imports: [
    CommonModule,
    LmoRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    UIComponentsModule,
    MatBadgeModule,
    AreaChartModule,
    LineChartModule,
    ChartCommonModule,
    BubbleChartModule,
    MatGridListModule,
    DragDropModule,
    NgxMaterialTimepickerModule,
    RatingModule,
    ChartsModule,
  ],
})
export class LmoModule {}
